module.exports = __webpack_public_path__ + "img/icon_map_51_on_100.4bf98419.png";